export const materialsStructure = {
  presentation: { file: 'presentation.pdf', category: 'Presentation' },
  rules: { file: 'rules.docx', category: 'Rules' },
  'promo pack': {
    file: 'promo pack.zip',
    category: 'Promotion Pack',
    expand: 'Files',
    open: true,
    subCategory: {
      banners: {
        file: 'banners.zip',
        category: 'Banners',
        expand: 'Sizes',
        countColumns: 4,
        pack: ['jpg', 'psd'],
        showPreviews: true,
      },
      'game thumbs': {
        file: 'game thumbs.zip',
        category: 'Game Thumbs',
        expand: 'Sizes',
        countColumns: 4,
      },
      gif: { file: 'gif.gif', category: 'Gif' },
      logo: { file: 'logo.zip', category: 'Logo' },
    },
  },
};

export const CATEGORIES = {
  comingSoon: {
    label: 'Coming Soon',
    value: 'comingSoon',
  },
  running: {
    label: 'Running',
    value: 'running',
  },
  ended: {
    label: 'Ended',
    value: 'ended',
  },
};

export const LIMITS = {
  running: 4,
  comingSoon: 4,
  ended: 6,
};

export const TAGS = {
  tournaments: 'TOURNAMENTS',
  prizeDrops: 'PRIZE_DROPS',
  wheelOfFortune: 'WHEEL_OF_FORTUNE',
};

export const TAG_COLORS = {
  [TAGS.tournaments]: {
    color: '#F0338C',
    backgroundColor: 'rgba(240, 51, 140, 0.2)',
  },
  [TAGS.prizeDrops]: {
    color: '#A33EE8',
    backgroundColor: 'rgba(173, 71, 235, 0.2)',
  },
  [TAGS.wheelOfFortune]: {
    color: '#FF4C24',
    backgroundColor: 'rgba(255, 76, 36, 0.3)',
  },
};

export const MARKETS = ['Europe', 'MGA', 'Asia', 'Latin America'];
